import { render, staticRenderFns } from "./orderAddress.vue?vue&type=template&id=05c00d15&scoped=true&"
import script from "./orderAddress.vue?vue&type=script&lang=js&"
export * from "./orderAddress.vue?vue&type=script&lang=js&"
import style0 from "./orderAddress.vue?vue&type=style&index=0&id=05c00d15&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c00d15",
  null
  
)

export default component.exports